module.exports = __webpack_public_path__ + "img/sendIcon.dae9ed37.svg";